import React from "react";
import "../css/nanny.css";
import Header from "../Headers/Header";
import HeaderLink from "../Headers/HeaderLink";
import Stepper3 from "./Steppers/Stepper3";
import { MdArrowBackIos } from "react-icons/md";
import { Button } from "reactstrap";
import experience from "../img/experience_1.svg";
import LeftContent from "./LeftContent";

export default function Step4({
  currentStep,
  gotoMomKidCare,
  prev,
  handleChange,
  errors,
  handleSubmit,
  selectedHours,
  selectedExperience,
  _next,
  isDisabled,
}) {
  if (currentStep !== 4) {
    return null;
  }
  return (
    <React.Fragment>
      <div className="d-lg-block d-none">
        <Header />
      </div>
      <div className="d-lg-none d-block">
        <HeaderLink gotoMomKidCare={gotoMomKidCare} />
      </div>
      <div className="container p-lg-4  mt-lg-5">
        <div className="row mx-auto mb-2">
          {/* Partition  one*/}
          <div className="col-lg-5 p-lg-5 mt-lg-0 mt-5 pt-5 pt-lg-0">
            <LeftContent gotoMomKidCare={gotoMomKidCare} />
          </div>

          {/* Partition  second*/}
          <div className="col-lg-7 mt-2 ">
            {/* Right Title */}
            <div className="row d-lg-block d-none">
              <div className="col-lg-12 rightTitle">
                <p className="ml-1 ml-lg-0">
                  Just these last 2 questions then your profile will be complete
                </p>
              </div>
            </div>
            {/* Right Title 2nd */}
            <div className="row d-lg-block d-none">
              <div className="col-lg-12 rightTitleSecond">
                <p className="ml-1 ml-lg-0">
                  बस ये आखिरी 2 सवाल तो आपकी प्रोफाइल पूरी हो जाएगी
                </p>
              </div>
            </div>
            {/* Main Content Form*/}
            <div className="row mx-auto mx-lg-0 mb-lg-0 mb-5">
              <div className="col-lg-12 mt-1 mainContent rounded">
              <form className="pl-0" onSubmit={(e)=>_next(e)}>
                <div className="row p-3">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-12">
                        <div className="d-lg-none d-block">
                          <Stepper3 />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="backText d-flex align-items-center">
                          <p>
                            <MdArrowBackIos size="15" />
                            {prev}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 personal">
                    <p>
                      Duty Hours <span>(आप कितने घंटे काम कर सकते हैं)</span>
                    </p>
                  </div>
                  <div className="col-lg-12 horizontal-line">
                    <hr />
                  </div>

                  <div className="col-lg-12 check" style={{ marginTop: '-10px' }}>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="selectedHours"
                        value="6"
                        checked={selectedHours.includes('6')}
                        onChange={handleChange}
                        style={{
                          border: errors.selectedHours ? "2px solid red" : "",
                        }}
                      />
                      <label class="form-check-label" for="inlineRadio1">
                        6 Hrs{" "}
                        <span style={{ color: "#6B6B6B" }}>(6 घंटे)</span>
                      </label>
                    </div>
                    <div class="form-check mt-lg-0 mt-3">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="selectedHours"
                        onChange={handleChange}
                        checked={selectedHours.includes('12')}
                        value="12"
                        style={{
                          border: errors.selectedHours ? "2px solid red" : "",
                        }}
                      />
                      <label class="form-check-label" for="inlineRadio2">
                        12 Hrs{" "}
                        <span style={{ color: "#6B6B6B" }}>(12 घंटे)</span>
                      </label>
                    </div>
                    <div class="form-check mt-lg-0 mt-3">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="selectedHours"
                        value="24"
                        checked={selectedHours.includes('24')}
                        onChange={handleChange}
                        style={{
                          border: errors.selectedHours ? "2px solid red" : "",
                        }}
                      />
                      <label class="form-check-label" for="inlineRadio3">
                        24 Hrs <span style={{ color: "#6B6B6B" }}>(24 घंटे)</span>
                      </label>
                    </div>
                  </div>
                  {errors.selectedHours && (
                    <span className="custom-error ml-2">
                      {errors.selectedHours}
                    </span>
                  )}
                  <div className="col-lg-12 personal mt-4">
                    <p>
                      Working Experience<span> (काम का अनुभव) </span>
                    </p>
                  </div>
                  <div className="col-lg-12 horizontal-line">
                    <hr />
                  </div>

                  <div className="col-lg-12">
                    <div
                      className="inp"
                      style={{
                        width: "250px",
                        display: "flex",
                        padding: "6px",
                        alignItems: "center",
                        border: errors.selectedExperience
                          ? "2px solid red"
                          : "",
                      }}
                    >
                      <img
                        src={experience}
                        style={{
                          color: "#174D82",
                          width: "25px",
                          height: "35px",
                          padding: "3px",
                        }}
                      />
                      {/* <experience style={{ color: "#174D82",width:"20px" ,height:"20px" }} /> */}

                      <div
                        style={{
                          height: "25px",
                          margin: "0px 5px",
                          borderLeft: "1px solid #AFC9DE",
                          opacity: "0.7",
                          width: "0px",
                        }}
                      ></div>
                      <select
                        style={{
                          borderColor: "white",
                          color: "#6B6B6B",
                          fontSize: "13px",
                        }}
                        class="form-select"
                        name="selectedExperience"
                        id="inputGroupSelect01"
                        onChange={handleChange}
                        value={selectedExperience}
                      >
                        <option selected style={{ opacity: "0.1" }} value=''>
                          Select Experience
                        </option>
                        <option value="Fresher">Fresher</option>
                        <option value="0-6">Less than 1 yrs</option>
                        <option value="1-2">1 to 2 yrs</option>
                        <option value="2-3">2 to 3 yrs</option>
                        <option value="3-4">3 to 4 yrs</option>
                        <option value="5-10">5 to 10 yrs</option>
                        <option value="10+">More than 10 yrs</option>
                      </select>
                    </div>
                  </div>
                  {errors.selectedExperience && (
                    <span className="custom-error ml-2">
                      {errors.selectedExperience}
                    </span>
                  )}

                  <div className="col-lg-12 mt-5">
                    <Button
                      className="float-left px-4 py-2"
                      style={{
                        backgroundColor: "#00A2FF",
                        border: 0,
                        fontSize: "12px",
                        color: '#fff'
                      }}
                      disabled={isDisabled ? true : false}
                      type="submit"
                      onClick={(e)=>handleSubmit(e)}
                    >
                      SUBMIT
                    </Button>
                  </div>
                  <div
                    className="d-lg-block d-none row"
                    style={{ marginTop: "19.6px" }}
                  >
                    <Stepper3 />
                  </div>
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
